import React from 'react'

function CaseStudies() {
  return (
    <section class="wrapper custom-wrapper featured-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h2 class="block-title">Case Studies</h2>
                    <p class="text-300">While the primary purpose of your web development and design portfolio is to showcase your development and design capabilities, therefor prospective clients will also love to see how your work helped businesses achieve success. That's where the case studies comes in.</p>
                </div>
            </div>
            <div class="row feature-row">	
                <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <div class="product-thumb transition">
                        <div class="image"><img src="https://www.technowebsol.com/image/cache/catalog/PortFolio/birwazy-700x378.jpg" width="700" height="378" alt="BirWazy" title="BirWazy" class="img-responsive" /></div>
                        <div class="caption">
                            <h4>BirWazy</h4>
                            <p>PHP, MySql</p>
                            <a class="goto-link" href="http://www.birwazy.com" target="_blank"><i class="fa fa-link"></i></a> 
                        </div>
                    </div>
                </div>
                <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <div class="product-thumb transition">
                        <div class="image"><img src="https://www.technowebsol.com/image/cache/catalog/PortFolio/fitness-deal-700x378.jpg" width="700" height="378" alt="Fitness Deals" title="Fitness Deals" class="img-responsive" /></div>
                        <div class="caption">
                            <h4>Fitness Deals</h4>
                            <p>PHP, MySql, OpenCart</p>
                            <a class="goto-link" href="http://fitnessdeal.no" target="_blank"><i class="fa fa-link"></i></a> 
                        </div>
                    </div>
                </div>
                <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <div class="product-thumb transition">
                        <div class="image"><img src="https://www.technowebsol.com/image/cache/catalog/PortFolio/scorpioncontroller-700x378.jpg" width="700" height="378" alt="ScorpionController" title="ScorpionController" class="img-responsive" /></div>
                        <div class="caption">
                            <h4>ScorpionController</h4>
                            <p>PHP, MySql, OpenCart</p>
                            <a class="goto-link" href="http://www.scorpioncontrollers.com" target="_blank"><i class="fa fa-link"></i></a> 
                        </div>
                    </div>
                </div>
                <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <div class="product-thumb transition">
                        <div class="image"><img src="https://www.technowebsol.com/image/cache/catalog/PortFolio/scorpiondrone-700x378.jpg" width="700" height="378" alt="ScorpionDrones" title="ScorpionDrones" class="img-responsive" /></div>
                        <div class="caption">
                            <h4>ScorpionDrones</h4>
                            <p>PHP, MySql, OpenCart</p>
                            <a class="goto-link" href="http://www.scorpiondrones.com" target="_blank"><i class="fa fa-link"></i></a> 
                        </div>
                    </div>
                </div>
                <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <div class="product-thumb transition">
                        <div class="image"><img src="https://www.technowebsol.com/image/cache/catalog/PortFolio/uneke-mobile-cases-700x378.jpg" width="700" height="378" alt="Uneke Cases" title="Uneke Cases" class="img-responsive" /></div>
                        <div class="caption">
                            <h4>Uneke Cases</h4>
                            <p>PHP, MySql, OpenCart</p>
                            <a class="goto-link" href="http://unekecase-new.twsserver.com" target="_blank"><i class="fa fa-link"></i></a> 
                        </div>
                    </div>
                </div>
                <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <div class="product-thumb transition">
                        <div class="image"><img src="https://www.technowebsol.com/image/cache/catalog/PortFolio/searchslide-700x378.jpg" width="700" height="378" alt="SearchSlide" title="SearchSlide" class="img-responsive" /></div>
                        <div class="caption">
                            <h4>SearchSlide</h4>
                            <p>PHP, MySql, Various Search API</p>
                            <a class="goto-link" href="http://searchslide.co.uk" target="_blank"><i class="fa fa-link"></i></a> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default CaseStudies